import { createActions, createReducer } from "reduxsauce"

export const { Types, Creators } = createActions({
  toggleTab: ["activeTab"],
  showCoveragePage: ["page"],
  showCoverageSecuritiesPage: ["page"],
  showSecuritiesPage: ["page"],
  showCoverageDate: ["date"],
  resetCoverageDate: [],
}, {
  prefix: "ompnt/modules/upload-scan-preview/",
})

const INITIAL_STATE = {
  activeTab: "summary",
  numberOfTableRows: 10,
  coveragePage: 0,
  securitiesPage: 0,
  coverageSecuritiesPage: 0,
  coverageDate: null,
}

function handleToggleTab(state, { activeTab }) {
  return { ...state, activeTab }
}

function handleShowCoveragePage(state, { page }) {
  return { ...state, coveragePage: page }
}

function handleShowCoverageSecuritiesPage(state, { page }) {
  return { ...state, coverageSecuritiesPage: page }
}

function handleShowSecuritiesPage(state, { page }) {
  return { ...state, securitiesPage: page }
}

function handleShowCoverageDate(state, { date }) {
  return { ...state, coverageDate: date }
}

function handleResetCoverageDate(state) {
  return { ...state, coverageDate: null }
}

export const HANDLERS = {
  [Types.TOGGLE_TAB]: handleToggleTab,
  [Types.SHOW_COVERAGE_PAGE]: handleShowCoveragePage,
  [Types.SHOW_COVERAGE_SECURITIES_PAGE]: handleShowCoverageSecuritiesPage,
  [Types.SHOW_SECURITIES_PAGE]: handleShowSecuritiesPage,
  [Types.SHOW_COVERAGE_DATE]: handleShowCoverageDate,
  [Types.RESET_COVERAGE_DATE]: handleResetCoverageDate,
}

export default createReducer(INITIAL_STATE, HANDLERS)
